import FormattedMessage from 'I18n/components/FormattedMessage';
import { CategoryIdToAccessControlContentType } from '../constants/ContentTypes';
import { PublicAccessRuleTypeToAccessControl } from '../constants/AccessControlTypes';
import { jsx as _jsx } from "react/jsx-runtime";
export const getContentAccessControlPanelSaveSuccessNotification = ({
  contentCategoryId,
  contentCount,
  publicAccessRuleType
}) => {
  const accessControlType = PublicAccessRuleTypeToAccessControl[publicAccessRuleType];
  const accessControlContentType = CategoryIdToAccessControlContentType[contentCategoryId];
  return {
    message: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `contentAccessControl.modal.notifications.saveSuccess.body.${accessControlType}.${accessControlContentType}`,
      options: {
        count: contentCount
      }
    }),
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `contentAccessControl.modal.notifications.saveSuccess.title.${accessControlType}`
    }),
    type: 'success'
  };
};
export const getContentAccessControlPanelSaveFailureNotification = ({
  contentCategoryId,
  contentCount
}) => {
  const accessControlContentType = CategoryIdToAccessControlContentType[contentCategoryId];
  return {
    message: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "contentAccessControl.modal.notifications.saveFailure.body"
    }),
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `contentAccessControl.modal.notifications.saveFailure.title.${accessControlContentType}`,
      options: {
        count: contentCount
      }
    }),
    type: 'danger'
  };
};